module.exports = __webpack_public_path__ + "static/media/test14_2.95f3eaea.png";